import React, { useContext, useRef } from 'react';
import EventEmitter from 'eventemitter3';
import { createHOCWithHookInside } from '../../utils/hoc/createHOCWithHookInside';

const AppEventsContext = React.createContext<EventEmitter>(undefined);

export const AppEventsProvider: React.FC = ({ children }) => {
  const { current: appEvents } = useRef(new EventEmitter());
  return <AppEventsContext.Provider value={appEvents}>{children}</AppEventsContext.Provider>;
};

export const useAppEvents = () => ({ appEvents: useContext(AppEventsContext) });

export const withAppEvents = createHOCWithHookInside('WithAppEvents', useAppEvents);
